<template>
  <div v-if="groups.length > 0">
    <div class="ml-2 pb-4 text-body-1">{{ $t('conflict.previousGroupings') }}:</div>
    <option-block
      v-for="group in groups"
      :key="group.id"
      :options="group.members"
      :asGroup="true"
    />
  </div>
</template>
<script>
import OptionBlock from '@/components/global/OptionBlock';
import scenarioService from '@/services/scenarios.js';

export default {
  name: 'OptionGroups',
  components: { OptionBlock },
  data() {
    return {
      groups: [],
      loading: true,
    };
  },
  props: {
    scenario: {
      type: Object,
      required: true,
    },
  },
  computed: {

  },
  methods: {

    loadGroups(scenario) {
      this.loading = true;
      const projectId = this.$route.params.id;
      scenarioService.getOptionGroups(projectId, scenario.id)
        .then((response) => {
          this.groups = response.data;
        })
        .catch(error => {
          this.$emit('raison-event', { type: 'error', messages: [error] });
        })
        .finally(()=> {
          this.loading = false;
        });
    },

  },
  created() {
    this.loadGroups(this.scenario);
  },
};
</script>
<style>

</style>